import ServiceTemplate from '@/components/ServiceTemplate';

export default function CopyrightTransfers() {
  const data = {
    title: 'Copyright Transfer Services',
    subtitle: 'Professional copyright assignment and transfer services.',
    overviewTitle: 'Understanding Copyright Transfers',
    overviewImage: 'https://images.unsplash.com/photo-1605602517229-cdbfc3dfb70c',
    description: [
      'Copyright transfers involve conveying ownership rights from one party to another. Proper documentation is essential as copyright law requires transfers to be in writing to be valid.',
      'Our copyright transfer service handles all aspects of copyright assignments including drafting transfer agreements, Copyright Office recordation, and ensuring proper chain of title.',
      'We ensure your copyright transfer is legally valid, properly recorded, and protects all parties\' interests.'
    ],
    benefits: [
      { title: 'Legal Validity', description: 'Ensure transfers meet all legal requirements.' },
      { title: 'Written Agreements', description: 'Properly drafted transfer documents.' },
      { title: 'Copyright Office Recording', description: 'Official recordation with Copyright Office.' },
      { title: 'Chain of Title', description: 'Maintain clear ownership records.' },
      { title: 'Rights Definition', description: 'Clearly define transferred rights and limitations.' },
      { title: 'Due Diligence', description: 'Verify ownership before transfer.' }
    ],
    process: [
      { title: 'Transfer Planning & Documentation', description: 'Review requirements and prepare comprehensive transfer agreements and documents.' },
      { title: 'Execution & Verification', description: 'Coordinate proper execution, notarization, and verification of all transfer documents.' },
      { title: 'Recording & Compliance', description: 'File and record transfers with appropriate authorities and ensure ongoing compliance.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Single work registration',
        price: '$199',
        period: '+ filing fees ($45-$65)',
        features: [
          'Single work registration',
          'Copyright Office filing',
          'Application preparation',
          'Certificate delivery',
          'Email support',
          'Standard processing'
        ]
      },
      {
        name: 'Professional',
        description: 'Multi-work package',
        price: '$399',
        period: '+ filing fees',
        featured: true,
        features: [
          'Up to 5 works registration',
          'Expedited filing available',
          'Comprehensive documentation',
          'Priority processing',
          'Copyright monitoring (6 months)',
          'Phone support',
          'Enforcement consultation'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Portfolio management',
        price: '$799',
        period: '+ filing fees',
        features: [
          'Unlimited registrations',
          'Portfolio strategy planning',
          'Ongoing monitoring',
          'DMCA takedown services',
          'Infringement detection',
          'Legal representation',
          'Dedicated account manager'
        ]
      }
    ],
    faqs: [
      { question: 'What does copyright transfer include?', answer: 'Transfers can include all rights or specific rights like reproduction, distribution, adaptation, public performance, or display.' },
      { question: 'Must transfers be in writing?', answer: 'Yes, federal law requires exclusive copyright transfers and licenses to be in writing and signed by the transferor.' },
      { question: 'Should transfers be recorded?', answer: 'Recording with Copyright Office is not required but provides public notice, establishes priorities between conflicting transfers, and offers legal advantages.' },
      { question: 'Can I transfer partial rights?', answer: 'Yes, you can transfer specific rights while retaining others, or limit transfers by territory, duration, or medium.' },
      { question: 'What is a reversion right?', answer: 'Copyright law allows authors to reclaim transferred rights 35 years after transfer under certain circumstances.' },
      { question: 'How are transferred copyrights valued?', answer: 'Valuation considers factors like work type, revenue history, licensing potential, remaining term, and market conditions.' },
      { question: 'What about moral rights?', answer: 'Visual artists have moral rights (attribution and integrity) that survive transfer, though these can be waived in writing.' },
      { question: 'Can transfers be reversed?', answer: 'Generally no, though agreements may include buyback options, termination clauses, or reversion provisions for specific circumstances.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
